import AchievementContextProvider from "../../../context/achievement/provider";
import PageDetails from "../../general/details";
import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from "react-router-dom";
import {useContext, useEffect} from "react";
import AchievementContext from "../../../context/achievement/context";
import AppContext from "../../../context/app/context";
import Spin from "../../general/antd/spin";
import Descriptions from "../../general/antd/descriptions";
import {Descriptions as AntdDescriptions} from "antd";
import OldImage from "../../form-components/old-image";

interface Props {
}

const AchievementDetails: React.FC<Props> = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {id} = useParams();
    const {details, actions, loading} = useContext(AchievementContext);
    const {direction} = useContext(AppContext);

    useEffect(() => {
        const getDetails = async () => {
            id && (await actions.getDetails(Number(id)));
        };
        getDetails();
    }, [direction]);

    return (
        <PageDetails
            title={t("details")}
            subtitle={t("achievement_detail")}
            buttonName={`${t("update_achievement")}`}
            onClick={() => navigate(`/achievements/update/${id}`)}
        >
            {loading.includes("details") ? (
                <Spin/>
            ) : (
                <Descriptions size="small" column={1} bordered>
                    <AntdDescriptions.Item label={t("id")}>
                        {details?.id}
                    </AntdDescriptions.Item>

                    <AntdDescriptions.Item label={t("title")}>
                        {details?.title ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("videoLink")}>
                     {details?.videoLink}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("description")}>
                        {details?.description ?? "-"}
                    </AntdDescriptions.Item>

                    <AntdDescriptions.Item label={t("content")}>
                        {details?.content ?? "-"}
                    </AntdDescriptions.Item>
                        <AntdDescriptions.Item label={t("number_of_beneficiaries")}>
                        {details?.beneficiariesNumber ?? "-"}
                    </AntdDescriptions.Item>
                        <AntdDescriptions.Item label={t("city")}>
                        {details?.city.name ?? "-"}
                    </AntdDescriptions.Item>
                        <AntdDescriptions.Item label={t("donation_value")}>
                            {details?.donationValue ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("image")}>
                        {details?.image ? (
                            <OldImage preview src={details?.image?.url}/>
                        ) : (
                            "-"
                        )}
                    </AntdDescriptions.Item>
                </Descriptions>
            )}
        </PageDetails>
    )

}

const AchievementDetailsPage = () => {
    return (
        <AchievementContextProvider>
            <AchievementDetails/>
        </AchievementContextProvider>
    );
};
export default AchievementDetailsPage;